// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"37":"d4624ffa","73":"813d9e05","74":"2b1e3da8","127":"d3ddf55a","213":"27592bb2","258":"90e48888","341":"e1e14577","591":"ebea871d","604":"0a9ca3a5","630":"30d50966","666":"7c223a65","731":"2f6eadbf","837":"1da44e87"}[chunkId] + ".js";
};